import { Component, OnChanges, SimpleChanges } from "@angular/core";
import { CustomButton } from "../../models/customButton";
import { Device } from "../../models/device";
import { DevicesService } from "../../services/devices.service";
import { CommonModule } from "@angular/common";
import { Router } from '@angular/router';
import { FormsModule } from "@angular/forms";
import { LoginUserModel } from "../../models/loginUserModel";
import { AlertModalComponent } from "../../utils/alert-modal/alert-modal.component";
import { LoaderComponent } from "../../utils/loader/loader.component";
import { ConfirmRequestComponent } from "../../utils/confirm-request/confirm-request.component";
import { Title } from "@angular/platform-browser";
import { ThemeService } from "../../theme.service";
import { environment } from "../../../environments/environment";
import { TableModule } from "primeng/table";
import { ToggleSwitchModule } from "primeng/toggleswitch";
import { InputTextModule } from "primeng/inputtext";
import { ButtonModule } from "primeng/button";
import { IconFieldModule } from "primeng/iconfield";
import { InputIconModule } from "primeng/inputicon";
import { SelectButtonModule } from "primeng/selectbutton";
import { SelectModule } from "primeng/select";
import { TooltipModule } from "primeng/tooltip";
import { DialogModule } from "primeng/dialog";
import { ToastService } from "../../services/toast.service";

@Component({
    selector: 'app-devices',
    imports: [
      CommonModule, FormsModule, AlertModalComponent, LoaderComponent,
      ConfirmRequestComponent, TableModule,
      ToggleSwitchModule, InputTextModule, ButtonModule,
      IconFieldModule, InputIconModule, SelectButtonModule, SelectModule, TooltipModule,
      DialogModule
    ],
    templateUrl: './devices.component.html',
    styleUrl: './devices.component.scss'
})
export class DevicesComponent implements OnChanges {
  searchTxt = "";
  buttonTables: CustomButton[] = [];
  enabledCards: any[] = [];
  disabledCards: any[] = [];
  selectedCardsForPrint: any[] = [];
  changedCards: any[] = [];
  tableData: any[] = [];
  filteredTable: any[] = [];
  showPrintColumn = false;
  statusFilter = 'X';
  inProcess = false;
  isSuccess = false;
  isConfirm = true;
  openModal = false;
  messageModal = '';
  isResponse = false;
  isSaving = false;
  isHTML = false;
  isLoading = true;
  showAlert = false;
  messageLoading = 'Cargando';
  messageAlert = '';
  statusAll = false;
  reporterURL = environment.wrUrl;
  alertDays = 15;
  showRenewDialog = false;
  renewingCard: any = null;
  renewing = false;
  showRenewColumn = false;
  selectedCardsForRenew: any[] = [];
  emptyTableMessage = "No hay dispositivos para mostrar";
  rowsPerPage = 10;

  statusOptions = [
    { label: 'Todos', value: 'X' },
    { label: 'Activos', value: 'A' },
    { label: 'Inactivos', value: 'I' }
  ];

  groups: any[] = [];
  groupFilter: number | null = null;
  private groupCardMap: Map<number, Set<number>> = new Map();

  headers = [
    { key: 'vehicleFullNumber', textHeader: 'Dispositivo' },
    { key: 'nameUser', textHeader: 'Usuario' },
    { key: 'description', textHeader: 'Vehículo' },
    { key: 'plates', textHeader: 'Placas' },
    { key: 'economicNumber', textHeader: 'No. Eco.' },
    { key: 'department', textHeader: 'Departamento' }
  ];

  data!: LoginUserModel;

  constructor(
    private services: DevicesService,
    private router: Router,
    private titleService: Title,
    private themeService: ThemeService,
    private toastSrv: ToastService
  ) {
    this.titleService.setTitle("Dispositivos");
    this.themeService.setTitle("Dispositivos");
    this.data = JSON.parse(localStorage.getItem('data')!);
  }

  ngOnInit() { this.loadDevices(); this.loadGroups(); }
  ngOnChanges(changes: SimpleChanges) {}

  loadGroups() {
    this.services.getGroups(this.data.Client_id).subscribe({
      next: (resp: any) => {
        this.groups = resp.response || [];
        // Load card assignments for each group
        this.groups.forEach(g => {
          this.services.getGroupCards(this.data.Client_id, g.groupId).subscribe({
            next: (r: any) => {
              const cardIds = (r.response?.assignedList?.items || []).map((i: any) => i.cardId);
              this.groupCardMap.set(g.groupId, new Set(cardIds));
            }
          });
        });
      },
      error: () => { this.groups = []; }
    });
  }

  onStatusFilterChange() { this.applyFilters(); }
  onGroupFilterChange() { this.applyFilters(); }

  applyFilters() {
    this.searchTxt = "";
    this.filteredTable = this.tableData.filter(e =>
      (this.statusFilter === 'X' || e.cardStatus === this.statusFilter) &&
      (this.groupFilter == null || this.groupCardMap.get(this.groupFilter)?.has(e.cardId))
    );
  }

  searchByText(event: any) {
    const q = event.target.value.toLowerCase();
    this.filteredTable = this.tableData.filter(item =>
      (this.statusFilter === 'X' || item.cardStatus === this.statusFilter) &&
      (this.groupFilter == null || this.groupCardMap.get(this.groupFilter)?.has(item.cardId)) &&
      Object.values(item).some(val => val != null && val.toString().toLowerCase().includes(q))
    );
  }

  loadDevices() {
    this.isLoading = true;
    this.services.loadDevices(this.data.Client_number, this.data.User_id, "", true).subscribe({
      next: (resp: any) => {
        this.tableData = resp;
        this.filteredTable = this.tableData;
        
        resp.forEach((el: Device) => {
          
          (el.cardStatus === 'A' ? this.enabledCards : this.disabledCards).push(el);
        });

        if(this.enabledCards.length==this.tableData.length){
          this.statusAll=true;
        }
        this.isLoading = false;
      },
      error: () => { this.isLoading = false; this.tableData = []; }
    });
  }

  getStatusModel(item: any): boolean { return item.cardStatus === 'A'; }

  getGroupName(item: any): string | null {
    for (const g of this.groups) {
      if (this.groupCardMap.get(g.groupId)?.has(item.cardId)) return g.description;
    }
    return null;
  }

  onSwitchChange(value: boolean, item: any) { this.changeDeviceStatus(value, item); }

  changeStatusOnSlider(event: any) { this.changeDeviceStatus(event.status, event.card); }

  changeDeviceStatus(status: any, item: any) {
    const card = item;
    if (status) {
      this.filteredTable.find((e: any) => e.cardId === card.cardId).cardStatus = 'A';
      if (this.disabledCards.findIndex((e: any) => e.cardId === card.cardId) > -1) {
        card.cardStatus = 'A';
        this.changedCards.push(card);
      } else {
        const idx = this.changedCards.findIndex((c: any) => c.cardId === card.cardId);
        if (idx > -1) this.changedCards.splice(idx, 1);
      }
    } else {
      this.tableData.find((e: any) => e.cardId === card.cardId).cardStatus = 'I';
      if (this.enabledCards.findIndex((e: any) => e.cardId === card.cardId) > -1) {
        card.cardStatus = 'I';
        this.changedCards.push(item);
      } else {
        const idx = this.changedCards.findIndex((c: any) => c.cardId === card.cardId);
        if (idx > -1) this.changedCards.splice(idx, 1);
      }
    }
  }

  changeAllStatus(event: boolean) {
    this.statusAll = event;
    this.filteredTable.forEach(el => this.changeDeviceStatus(event, el));
  }

  getItem(device: Device) { this.router.navigate(['app/dispositivo/' + device.cardId]); }

  isSelected(item: Device) { return this.selectedCardsForPrint.findIndex(c => c.cardId === item.cardId) > -1; }

  selectItemForPrint(item: Device) {
    const idx = this.selectedCardsForPrint.findIndex(c => c.cardId === item.cardId);
    idx > -1 ? this.selectedCardsForPrint.splice(idx, 1) : this.selectedCardsForPrint.push(item);
  }

  openModalToPrint() {
    this.openModal = true;
    const word = this.selectedCardsForPrint.length === 1 ? ' dispositivo' : ' dispositivos';
    this.messageModal = 'Se enviará una solicitud para reimpresión de ' + this.selectedCardsForPrint.length + word + ', ¿Desea continuar?';
  }

  sendRequestToPrint(event: any) {
    this.openModal = false;
    this.isSaving = true;
    this.selectedCardsForPrint.forEach(el => {
      if (el.deviceType === 'UP' && el.cardStatus === 'A' && (el.vehicleType === 'HQR' || el.vehicleType === 'TV') && !el.isAppEnabled) {
        el.deliveryId = parseInt(event);
      }
    });
    if (this.selectedCardsForPrint.length > 0) {
      this.services.sendRequestToPrint(this.selectedCardsForPrint, this.data.Client_number, this.data.UserType === 'Administrator' ? 'Administrador de la cuenta' : this.data.Name).subscribe({
        next: (resp: any) => {
          this.isSaving = false; this.selectedCardsForPrint = []; this.showPrintColumn = false;
          this.isConfirm = false; this.isSuccess = true; this.openModal = true;
          this.messageModal = resp > 0 ? 'La solicitud de reimpresión se ha enviado con éxito con el Folio: <b> # ' + resp + ' </b>' : 'La solicitud de reimpresión se ha enviado con éxito';
          this.isHTML = resp > 0;
        },
        error: () => {
          this.isSaving = false; this.isConfirm = false; this.isSuccess = false;
          this.openModal = true; this.messageModal = 'Sucedió un problema al solicitar la reimpresión, intente de nuevo'; this.isHTML = false;
        }
      });
    } else {
      this.isSaving = false; this.isConfirm = false; this.isSuccess = false;
      this.openModal = true; this.messageModal = 'Estimado cliente, debe tener al menos un dispositivo con holograma seleccionado para reimpresión';
    }
  }

  resetModal() { this.isHTML = false; this.isConfirm = true; this.messageModal = ''; this.isSuccess = false; }

  saveChangedDevices() {
    this.isSaving = true; this.messageLoading = 'Guardando';
    if (this.changedCards.length > 0) {
      this.services.changeDevicesStatus(this.changedCards, this.data.Client_number, this.data.UserType === 'Administrator' ? 'Administrador de la cuenta' : this.data.Name).subscribe({
        next: (resp: any) => {
          this.isConfirm = false; this.isSaving = false; this.showAlert = true;
          if (resp.code === 1) { this.isSuccess = true; this.messageAlert = resp.msg; this.changedCards = []; this.loadDevices(); }
          else { this.isSuccess = false; this.messageAlert = resp.msg; }
        },
        error: () => { this.isSuccess = false; this.messageAlert = 'Sucedió un error, intente de nuevo'; }
      });
    }
  }

  addDevice() { this.router.navigate(['app/agregar/dispositivo']); }

  downlolad(format: string) {
    const base = this.reporterURL;
    const url = format === 'PDF'
      ? base + 'Pdf/MonederoXiga.aspx?rptId=data&rptName=rpt_devices&client=' + this.data.Client_number
      : base + 'Excel/MonederoXiga.aspx?rptName=devices&client=' + this.data.Client_number;
    window.open(url, "_blank");
  }

  isExpired(item: any): boolean {
    return new Date(item.expirationDate) < new Date();
  }

  isExpiringSoon(item: any): boolean {
    const today = new Date();
    const expDate = new Date(item.expirationDate);
    const diffDays = Math.floor((expDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
    return diffDays >= 0 && diffDays <= this.alertDays;
  }

  renewCard(item: any) {
    this.renewingCard = item;
    this.showRenewDialog = true;
  }

  confirmRenew() {
    if (this.renewingCard) {
      this.renewing = true;
      this.services.renewCardExpiration(this.data.Client_number, [this.renewingCard.cardId]).subscribe({
        next: (resp: any) => {
          this.renewing = false;
          this.showRenewDialog = false;
          if (resp.isSuccess) {
            this.renewingCard.expirationDate = new Date(new Date().setFullYear(new Date().getFullYear() + 4)).toISOString();
            this.toastSrv.add({ type: 'success', message: resp.message });
          }
        },
        error: () => {
          this.renewing = false;
          this.showRenewDialog = false;
          this.toastSrv.add({ type: 'error', message: 'Error al renovar vigencia' });
        }
      });
    } else {
      this.executeBatchRenew();
    }
  }

  // Selección masiva para renovación
  get expiringCards(): any[] {
    return this.filteredTable.filter(item => this.isExpired(item) || this.isExpiringSoon(item));
  }

  isSelectedForRenew(item: any): boolean {
    return this.selectedCardsForRenew.some(c => c.card_id === item.card_id);
  }

  toggleRenewSelection(item: any) {
    if (this.isSelectedForRenew(item)) {
      this.selectedCardsForRenew = this.selectedCardsForRenew.filter(c => c.card_id !== item.card_id);
    } else {
      this.selectedCardsForRenew.push(item);
    }
  }

  selectAllForRenew(checked: boolean) {
    this.selectedCardsForRenew = checked ? [...this.expiringCards] : [];
  }

  confirmBatchRenew() {
    this.renewingCard = null;
    this.showRenewDialog = true;
  }

  executeBatchRenew() {
    this.renewing = true;
    const ids = this.selectedCardsForRenew.map(c => c.cardId);
    this.services.renewCardExpiration(this.data.Client_number, ids).subscribe({
      next: (resp: any) => {
        this.renewing = false;
        this.showRenewDialog = false;
        if (resp.isSuccess) {
          const newDate = new Date(new Date().setFullYear(new Date().getFullYear() + 4)).toISOString();
          this.selectedCardsForRenew.forEach(c => c.expirationDate = newDate);
          this.selectedCardsForRenew = [];
          this.showRenewColumn = false;
          this.toastSrv.add({ type: 'success', message: resp.message });
        }
      },
      error: () => {
        this.renewing = false;
        this.showRenewDialog = false;
        this.toastSrv.add({ type: 'error', message: 'Error al renovar vigencia' });
      }
    });
  }
}
